<template>
    <div class="personalMain">
      <p class="current">当前位置：<span>个人中心</span><i class="el-icon-arrow-right"></i><span>专家订单</span></p>
      <div class="personal-box">
        <personalMenu></personalMenu>
        <div class="MainInfo">
            <p class="currTitle">专家订单</p>
            <!-- <div v-for="item in 6" class="bookingItems">
               <div>
                    <p class="itemsTitle">专家： nihao</p>
                    <p>订单： 2893547545394535</p>
                    <p>时间： 2023-08-03 10:33:30</p>
               </div>
               
               <div>
                    <el-button round >详情</el-button>
               </div>
            </div>
             -->
            <div v-if="vsData == ''" class="teamsNull">
                <p>亲，未找到记录~</p>
            </div>
           
           <div v-for="item in vsData" :key="item.id"  class="bookingItems">
                <div>
                    <p class="itemsTitle">专家：{{ item.expert_name }}</p>
                    <div>
                        <p>订单：{{ item.order_no }}</p>
                        <p>时间：{{ item.create_time }}</p>
                       
                    </div>  
                </div>
               
                <div>
                    <el-button round @click="HandleInfo(item)">详情</el-button>
                </div>
               
              
            </div>
            
          
            <div style="text-align: right;">
                <el-pagination
                    :hide-on-single-page="hideOnSinglePage"
                    :page-size="20"
                    :pager-count="11"
                    @current-change="handleCurrentChange"
                    layout="prev, pager, next"
                    :total="total">
                </el-pagination>
            </div>
        </div>
      </div>
    </div>
  </template>
  
<script>
import personalMenu from './index.vue'
export default {
    data(){
        return{
            total: 0,
            hideOnSinglePage: true,
            vsData: []
        }
    },
    components:{
        personalMenu
    },
    methods: {
        listSelf(data){
            this.$store.dispatch('expert/listSelf',data)
            .then(res => {
                if(res.ok){
                    var items = res.data.items
                    this.total = res.data.total
                    if(this.total <= 10){
                        this.hideOnSinglePage = true
                    }else{
                        this.hideOnSinglePage = false
                    }

                    var dpn = items.length
                    if(dpn > 0){
                        items.forEach(item => {
                            const timeDate = new Date(item.create_time)
                            item.create_time = this.getDateTime(timeDate)
                        });

                        this.vsData = items
                       
                    
                    }
                }
            })
        },
        getDateTime(timeDate){
            const year = timeDate.getFullYear();
            const month = (timeDate.getMonth() + 1).toString().padStart(2, '0');
            const day = timeDate.getDate().toString().padStart(2, '0');
            const hours = timeDate.getHours().toString().padStart(2, '0');
            const minutes = timeDate.getMinutes().toString().padStart(2, '0');
            const seconds = timeDate.getSeconds().toString().padStart(2, '0');
            const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

            return formattedDate
        },
        handleCurrentChange(val){
            console.log(`当前页: ${val}`);
            let listSign = {
                pageNum: val,
                pageSize: '20',
                is_pay: '1'
        
            }
            this.listSelf(listSign)
        },
        HandleInfo(val){
            const {href} = this.$router.resolve({
                path: '/infoSelf',
                query: {
                    order_no: val.order_no
                }
            })
            window.open(href, '_blank')
        },
       
    
    },
    mounted(){
        
       
    },
    created(){
        localStorage.setItem('active','2-5')

        let data = {
            pageNum: '1',
            pageSize: '20',
            is_pay: '1'
        }
       this.listSelf(data)
        // let listFav = {
        //     pageNum: 1,
        //     pageSize: 10
        // }
        // this.listByUser(listFav)
    }
}
</script>


<style scoped lang="scss">
@import url(../../css/personal.css);
.bookingItems{
    margin: 10px 0 20px 0;
    padding: 10px 10px 25px 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 0.5px solid #f2f2f2;
    p{
        /* font-size: 16px; */
        font-size: 18px;
        color: #666666;
        line-height: 30px;
    }
    .itemsTitle{
    
        margin-bottom: 9px;
        font-size: 20px;
        color: #000;
    }
}
.teamsNull{
    font-size: 18px;
    color: #666666;
    text-align: center;
    margin-top: 40px;
}

  </style>